<body>
    <div class="app">
        <aside class="sidebar" aria-hidden="false">
            <div class="brand">
                <div>
                    <h1>Presorteo</h1>
                    <p>Sistema de números aleatorios</p>
                </div>
            </div>


            <div class="options">
                <div class="opt">
                    <div class="title">Rango</div>
                    <div class="hint">Ej: 1 - 4</div>
                </div>
                <div class="opt">
                    <div class="title">Formato de salida</div>
                    <div class="hint">Aleatorios</div>
                </div>
            </div>


            <div class="note">
                Opciones a la izquierda
            </div>
        </aside>


        <main class="main">
            <section class="card" role="region" aria-label="Presentación de Megaloto">
                <div class="hero-left">
                    <h2 class="title">Presorteo — Generador de números aleatorios</h2>
                    <p class="lead">El presorteo es un sistema ligero y confiable para generar combinaciones
                        numéricas </p>


                    <div class="feature-list">
                        <div class="feature">
                            <div class="dot"></div>
                            <p>Configuracion de rango de numeros para los set de bolillas</p>
                        </div>
                        <div class="feature">
                            <div class="dot"></div>
                            <p>Permite descargar nuevamente reportes ya generados</p>
                        </div>
                    </div>
                </div>


                <aside class="hero-right">
                    <div class="visual" aria-hidden="true">
                        <div class="example-text">Ejemplo de combinación</div>
                        <div class="numbers" aria-hidden="true">
                            <div class="num">04</div>
                            <div class="num">01</div>
                            <div class="num">03</div>
                            <div class="num">02</div>
                        </div>
                        <div class="muted">Salida generada</div>
                    </div>
                </aside>
            </section>
        </main>
    </div>
</body>